module.exports = __webpack_public_path__ + "static/media/branch.89c97a03.jpeg";